/* eslint-disable react/prop-types */
// Weather.jsx
import React from 'react'

const WeatherDefault = ({ style }) => <Weather style={style} />

export default WeatherDefault

const Weather = ({ style }) => {
  const svgStyle = { fill: '#284047', ...style }
  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>weather icon</description>
      <title>weather</title>
      <g
        style={{
          transform: 'translate(16px, 11px) scale(0.7)',
        }}
      >
        <path d='M54.1,52.5V17.7c0-4-3.3-7.3-7.3-7.3s-7.3,3.3-7.3,7.3v2.6c-5.8-9-12.3-16.7-12.3-16.8
          c-0.3-0.3-0.7-0.5-1.2-0.5c-0.4,0-0.9,0.2-1.2,0.5C24,4.6,2.8,30.3,2.8,42.7C2.8,55.6,13.2,66,26.1,66c3,0,6-0.6,8.7-1.7
          c1,5.8,6,10.2,12.1,10.2c6.7,0,12.2-5.5,12.2-12.2C59.1,58.4,57.2,54.8,54.1,52.5z M36.8,55.3c-0.2,0.3-0.3,0.5-0.5,0.8
          c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.3-0.3,0.7-0.4,1c0,0.1,0,0.1-0.1,0.2
          c-0.1,0.4-0.2,0.7-0.3,1.1c0,0,0,0.1,0,0.1c-0.1,0.4-0.1,0.8-0.2,1.2C32,62.4,29.1,63,26.1,63C14.9,63,5.8,53.9,5.8,42.7
          c0-9.8,15.8-30.3,20.3-35.9c2.5,3.1,8.6,11,13.5,19.1v26.6c-0.4,0.3-0.7,0.6-1,0.9c-0.2,0.2-0.3,0.3-0.5,0.5
          c-0.1,0.1-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.5,0.7C37,55.1,36.9,55.2,36.8,55.3z M46.8,71.6c-5.1,0-9.2-4.1-9.2-9.2
          c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0.1-2.3,1-4.5,2.5-6.1c0,0,0,0,0,0c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.6-0.5,0.9-0.7
          c0.4-0.3,0.7-0.8,0.7-1.3V25.5v-7.8c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3v35.6c0,0.5,0.3,1,0.7,1.3c2.7,1.7,4.2,4.6,4.2,7.8
          C56.1,67.4,51.9,71.6,46.8,71.6z'
        />
        <path d='M48.9,56.2V28.9c0-1.1-0.9-2.1-2.1-2.1s-2.1,0.9-2.1,2.1v27.3c-2.5,0.9-4.3,3.2-4.3,6c0,3.5,2.8,6.4,6.4,6.4
          c3.5,0,6.4-2.8,6.4-6.4C53.2,59.4,51.4,57,48.9,56.2z'
        />
        <path d='M21.1,55.8c-3.7-1.2-6.7-4.1-8.1-7.7c-0.3-0.8-1.2-1.2-1.9-0.9c-0.8,0.3-1.2,1.2-0.9,1.9c1.7,4.5,5.4,8,10,9.5
          c0.2,0.1,0.3,0.1,0.5,0.1c0.6,0,1.2-0.4,1.4-1C22.3,56.9,21.9,56.1,21.1,55.8z'
        />
      </g>
    </svg>
  )
}
